import { API_BASE_URL } from "src/config/apiBase";

export function buildRecurringListQuery({
  mainId,
  statusTab = "all",
  searchQuery = "",
  customerFilter = "",
  frequencyFilter = "",
  customDate = {},
  summaryPeriod = "All Time",
  sortField = "next_run",
  sortOrder = "asc",
  page = 1,
  limit = 10,
}) {
  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("limit", String(limit));
  params.set("sort", sortField);
  params.set("order", sortOrder);

  if (statusTab && statusTab !== "all") params.set("status", statusTab);
  if (searchQuery?.trim()) params.set("q", searchQuery.trim());
  if (customerFilter) params.set("customer", customerFilter);
  if (frequencyFilter) params.set("frequency", frequencyFilter);
  if (customDate?.from) params.set("next_run_from", customDate.from);
  if (customDate?.to) params.set("next_run_to", customDate.to);

  if (typeof summaryPeriod === "string") {
    params.set("period", summaryPeriod);
  } else if (summaryPeriod?.type === "Custom Date") {
    params.set("period_from", summaryPeriod.from || "");
    params.set("period_to", summaryPeriod.to || "");
  }

  return `${API_BASE_URL}/newinvoice/recurring/all/${mainId}?${params.toString()}`;
}

export async function fetchRecurringList({ mainId, token, ...filters }) {
  const res = await fetch(buildRecurringListQuery({ mainId, ...filters }), {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load schedules");
  return data;
}

export async function fetchAllRecurringTemplates(mainId, token) {
  const res = await fetch(`${API_BASE_URL}/newinvoice/recurring/all/${mainId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Failed to load schedules");
  return Array.isArray(data) ? data : data.items || [];
}

export async function bulkRecurringAction(path, ids, mainId, token) {
  const res = await fetch(`${API_BASE_URL}/newinvoice/recurring/bulk/${path}`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ ids, user_id: mainId }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Bulk action failed");
  return data;
}

export async function processDueRecurring(mainId, token) {
  const res = await fetch(`${API_BASE_URL}/newinvoice/recurring/process-due`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user_id: mainId }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Process due failed");
  return data;
}

export async function fetchRecurringExportRows({ mainId, token, ...filters }) {
  const data = await fetchRecurringList({
    mainId,
    token,
    ...filters,
    page: 1,
    limit: 500,
  });
  return data.items || [];
}
